import { useCms } from "./useCms";
import { Field, Panel } from "./Fields";

const SOCIALS = ["linkedin", "facebook", "instagram", "youtube", "twitter"];

export default function GlobalEditor() {
  const { data, setData, save, saving } = useCms("settings", {});
  const s = data || {};
  const set = (k, v) => setData({ ...s, [k]: v });
  const trust = s.trust_items || [];

  return (
    <Panel title="Contact, Trial & Global Settings" description="These apply across the whole website (header, footer, trial flow, promo banner)." onSave={() => save(s)} saving={saving} saveTestid="global-save">
      <div className="grid md:grid-cols-2 gap-4">
        <Field label="WhatsApp number (with country code, digits only)" value={s.whatsapp_number} onChange={(v) => set("whatsapp_number", v)} testid="global-whatsapp" />
        <Field label="Contact / sales email" value={s.contact_email} onChange={(v) => set("contact_email", v)} testid="global-email" placeholder="sales@company.com" />
        <Field label="Trial duration (days)" type="number" value={s.trial_days} onChange={(v) => set("trial_days", Number(v))} testid="global-trial-days" />
        <Field label="Verification amount (paise — 100 = ₹1)" type="number" value={s.trial_verification_amount} onChange={(v) => set("trial_verification_amount", Number(v))} />
        <div className="md:col-span-2">
          <Field label="Footer tagline" multiline value={s.footer_tagline} onChange={(v) => set("footer_tagline", v)} testid="global-footer-tagline" placeholder="One powerful platform to manage Finance, HR, Attendance, Payroll, Expenses, Invoices and Business Operations." />
        </div>
        <div className="md:col-span-2">
          <Field label="Promo banner text (empty = hidden)" value={s.promo_banner?.text || ""} onChange={(v) => set("promo_banner", { enabled: !!v, text: v })} testid="global-promo" />
        </div>
      </div>
      <h3 className="font-semibold text-slate-900 text-sm mt-6 mb-3">Trust strip items (homepage dark band)</h3>
      <div className="grid md:grid-cols-4 gap-3">
        {[0, 1, 2, 3].map((i) => (
          <div key={i} className="space-y-2">
            <Field label={`Item ${i + 1} label`} value={trust[i]?.label} onChange={(v) => { const n = [...trust]; n[i] = { ...(n[i] || {}), label: v }; set("trust_items", n); }} />
            <Field label="Value (optional)" value={trust[i]?.value} onChange={(v) => { const n = [...trust]; n[i] = { ...(n[i] || {}), value: v }; set("trust_items", n); }} />
          </div>
        ))}
      </div>
      <h3 className="font-semibold text-slate-900 text-sm mt-6 mb-3">Social links (shown in footer when filled)</h3>
      <div className="grid md:grid-cols-3 gap-3">
        {SOCIALS.map((k) => (
          <Field key={k} label={k[0].toUpperCase() + k.slice(1) + " URL"} value={s.social?.[k]} onChange={(v) => set("social", { ...(s.social || {}), [k]: v })} testid={`global-social-${k}`} placeholder="https://" />
        ))}
      </div>
    </Panel>
  );
}
